<script>
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn } from 'devextreme-vue/data-grid';

    const ANOMALY_TYPE_LABELS = {
        0: 'Data Delayed',
        1: 'Tank Null Value',
        2: 'Tank Limit Exceeded',
        3: 'Tank Negative Gauge'
    };

    export default {
        components: {
            AdminGrid,
            DxColumn
        },
        data() {
            return {
                items: [],
                isLoading: false
            };
        },
        methods: {
            async loadData() {
                this.isLoading = true;
                try {
                    this.items = (await httpService.get('tiny-pumper/pending-issues')) ?? [];
                } finally {
                    this.isLoading = false;
                }
            },
            anomalyTypeLabel(value) {
                return ANOMALY_TYPE_LABELS[value] ?? value;
            },
            ageDays(createdDate) {
                const ms = new Date() - new Date(createdDate);
                return Math.floor(ms / (1000 * 60 * 60 * 24));
            }
        },
        mounted() {
            this.loadData();
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi-exclamation-triangle"></i>
            TinyPumper Pending Issues
        </h3>
    </div>
    <div class="main-content-body">
        <AdminGrid :dataSource="items" :isLoading="isLoading" storageKey="tiny-pumper-pending-issues">
            <DxColumn data-field="companyName" caption="Company" />
            <DxColumn data-field="batteryName" caption="Facility" />
            <DxColumn data-field="assetName" caption="Asset" />
            <DxColumn data-field="anomalyType" caption="Issue Type" :calculate-display-value="row => anomalyTypeLabel(row.anomalyType)" />
            <DxColumn data-field="createdDate" caption="First Seen" data-type="datetime" />
            <DxColumn data-field="lastOccurrenceDate" caption="Last Seen" data-type="datetime" />
            <DxColumn data-field="lastReport" caption="Last Alerted" data-type="datetime" />
            <DxColumn caption="Age (days)" :calculate-cell-value="row => ageDays(row.createdDate)" />
        </AdminGrid>
    </div>
</template>
